import { render, staticRenderFns } from "./listUser.vue?vue&type=template&id=52f40c39"
import script from "./listUser.vue?vue&type=script&lang=js"
export * from "./listUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports